import { motion } from "framer-motion";
import React from "react";
import { Box } from "~/design-system/Box";
import { Column, Columns } from "~/design-system/Columns";
import { useBreakpoint } from "~/design-system/hooks";
import { Placeholder } from "~/design-system/Placeholder";
import { SafeArea } from "~/design-system/SafeArea";
import { Stack } from "~/design-system/Stack";

const ProjectInfoSkeleton = () => {
  const { breakpoint } = useBreakpoint();
  const bannerHeight = breakpoint === "mobile" ? "33%" : "50%";
  return (
    <Box css={{ height: bannerHeight }} position="relative">
      <Placeholder
        marginBottom="xsmall"
        height="large"
        width="full"
        borderRadius="small"
      />
      <Placeholder height="medium" width="full" borderRadius="small" />
    </Box>
  );
};

const ProjectNotesSkeleton = () => {
  const { breakpoint } = useBreakpoint();
  const bannerHeight = breakpoint === "mobile" ? "33%" : "50%";
  return (
    <Box css={{ height: bannerHeight }} position="relative">
      <Placeholder
        marginBottom="xsmall"
        height="small"
        width="full"
        borderRadius="small"
      />
      <Placeholder
        marginBottom="xsmall"
        height="medium"
        width="full"
        borderRadius="small"
      />
    </Box>
  );
};

const ProjectTeamsSkeleton = () => {
  return (
    <Box height="full" position="relative">
      <Placeholder
        marginBottom="xsmall"
        height="full"
        width="full"
        borderRadius="small"
      />
    </Box>
  );
};

const ProjectMobileSkeleton = () => {
  return (
    <Box width="full" position="relative">
      <Placeholder
        marginBottom="xsmall"
        height="large"
        width="full"
        borderRadius="small"
      />
      <Placeholder
        marginBottom="xsmall"
        height="medium"
        width="full"
        borderRadius="small"
      />
      <Placeholder
        marginBottom="small"
        height="xlarge"
        width="full"
        borderRadius="small"
      />
      <Placeholder
        marginBottom="xsmall"
        height="xsmall"
        width="full"
        borderRadius="small"
      />
      <Placeholder
        marginBottom="small"
        height="large"
        width="full"
        borderRadius="small"
      />

      <Placeholder
        marginBottom="small"
        height="xlarge"
        width="full"
        borderRadius="small"
      />
    </Box>
  );
};

const ProjectListSkeleton = () => {
  const { breakpoint } = useBreakpoint();
  return (
    <motion.div
      style={{
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "flex-start",
        width: "100%",
      }}
      initial={{ opacity: 0.4 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.6,
        ease: "easeIn",
        repeat: Infinity,
        repeatType: "mirror",
      }}
    >
      <SafeArea top />
      {breakpoint === "desktop" ? (
        <Box width="full" paddingBottom="small">
          <Stack space="small">
            <Columns space="small">
              <Column width="2-3">
                <ProjectInfoSkeleton />
              </Column>
              <Column width="1-3">
                <ProjectTeamsSkeleton />
              </Column>
            </Columns>
            <Columns space="small">
              <Column width="2-3">
                <Stack space="xsmall">
                  <ProjectNotesSkeleton />
                  <Columns
                    css={{
                      height: "130px",
                    }}
                    space="small"
                  >
                    <Column
                      css={{
                        height: "100%",
                      }}
                      width="1-2"
                    >
                      <ProjectTeamsSkeleton />
                    </Column>
                    <Column width="1-2">
                      <ProjectTeamsSkeleton />
                    </Column>
                  </Columns>
                </Stack>
              </Column>
              <Column
                css={{
                  height: "50vh",
                }}
                width="1-3"
              >
                <ProjectTeamsSkeleton />
              </Column>
            </Columns>
          </Stack>
        </Box>
      ) : (
        <ProjectMobileSkeleton />
      )}
    </motion.div>
  );
};

export { ProjectListSkeleton };
